import React from 'react'
import type {TSignupRequestId} from '@kapitalist/contract/types'
import type {TAdminSignUpsResult} from '~/api/endpoints/admin/AdminSignUps'
import type {TNoFormFields} from '~/components/ProvideForm/base'
import FormSubmissionButton from '~/components/ProvideForm/FormSubmissionButton'
import ProvideForm from '~/components/ProvideForm/normal'
import {DSTextDiv} from '~/design-system/DSText'
import {formatDateByAge} from '~/utils/Date'
import styles from './styles.module.css'

interface IProps {
  signups: TAdminSignUpsResult['signupRequests']
  approveSignUp: (signupId: TSignupRequestId) => Promise<TAdminSignUpsResult>
  approveSignUpSubmitSuccess: (result: TAdminSignUpsResult) => void
}

interface IState {}

export default class AdminSignUpsUI extends React.Component<IProps, IState> {
  state: IState = {}

  render() {
    return (
      <div>
        <div className={styles.signupsGrid}>
          <>
            <DSTextDiv size="body-15" bold>
              Date
            </DSTextDiv>
            <DSTextDiv size="body-15" bold>
              Username
            </DSTextDiv>
            <DSTextDiv size="body-15" bold>
              Email
            </DSTextDiv>
            <div />
          </>
          {this.props.signups.map(su => (
            <React.Fragment key={su.id}>
              <DSTextDiv size="body-15">{formatDateByAge(su.createdAt)}</DSTextDiv>
              <DSTextDiv size="body-15">{su.username}</DSTextDiv>
              <DSTextDiv size="body-15">{su.email}</DSTextDiv>
              <ProvideForm<TNoFormFields, TAdminSignUpsResult>
                onSubmit={() => this.props.approveSignUp(su.id)}
                submitSuccess={(_, result) =>
                  this.props.approveSignUpSubmitSuccess(result)
                }
                toFormFields={(_generateFormFieldProps, formProps) => {
                  return (
                    <div className={styles.rowForm}>
                      <FormSubmissionButton
                        formProps={formProps}
                        size="14px"
                        buttonStyle="primary"
                      >
                        Approve
                      </FormSubmissionButton>
                    </div>
                  )
                }}
              />
            </React.Fragment>
          ))}

          {!this.props.signups.length && (
            <DSTextDiv size="body-15">No requests.</DSTextDiv>
          )}
        </div>
      </div>
    )
  }
}
